// extracted by mini-css-extract-plugin
module.exports = {"item":"SyncItems_item__10j3t","status":"SyncItems_status__3qWPw","name":"SyncItems_name__14mpU","platform":"SyncItems_platform__1j4V1"};